import mediumZoom from "medium-zoom";

const mediumZoomLib = mediumZoom({
  background: '#2e2925',
});

const zoom = {
  inserted(el) {
    const img = el.querySelector("img");
    // attach the zoom behavior to the image
    mediumZoomLib.attach(img);
    // if the button is selected via keyboard,
    // trigger a click on the image
    el.addEventListener("keypress", () => img.click());
  },
  unbind(el) {
    const img = el.querySelector("img");
    mediumZoomLib.detach(img);
    el.removeEventListener("keypress", () => img.click());
  },
};

export { zoom as default };
